module.exports = __webpack_public_path__ + "img/carousel-productos-7.38df1d02.jpg";